import React from 'react'
import styled from 'styled-components'
import { BlockLink, Button, Card, Flex, Hide, Text } from 'pcln-design-system'
import { buildContent } from './crossSellUtils'
import TripDetailsBox from './TripDetailsBox'
import { HotelBooking, FlightBooking, CarBooking } from './types'
import * as PCLNAnalytics from '../../../utils/PCLN-Analytics'

const HeadingText = styled(Text)`
  font-size: 32px;
  font-weight: bold;
  line-height: 36px;
  margin-bottom: 16px;
`

const ActionBox = styled(Flex)`
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  ${props => props.theme.mediaQueries[3]} {
     height: 100%;
     align-self: center;
     border-bottom-left-radius: 0;
     border-top-right-radius: 4px;
  }
`

const Wrapper = styled(Card)`
  height: 340px;
  ${props => props.theme.mediaQueries[3]} {
    height: 250px;
  }
  background-color: white;
  border-radius: 4px;
`

type CrossSellPromoProps = {
  firstName?: string,
  booking: FlightBooking | HotelBooking | CarBooking | null
}

export default function CrossSellPromo ({ firstName = '', booking }: CrossSellPromoProps) {
  const { product, xSellMessaging, date, headline, subHeadline, xSellTarget, xSellUrl } = buildContent(booking)

  return (
    <Wrapper boxShadowSize='md' mx={2} width={2 / 3}>
      <Flex justifyContent='space-between' style={{ height: '100%' }} flexDirection={['column', null, null, null, 'row']} >
        <Flex flexDirection='column' justifyContent='center' width={[1, null, null, null, 6 / 11]} px="24px" py={[3, null, null, null, 4]}>
          <HeadingText mb={2}>{firstName ? `${firstName}, your` : 'Your '} trip is coming up!</HeadingText>
          <Hide xs sm md lg>
            <Text fontSize={2} mb='24px'>{date}</Text>
          </Hide>
          <TripDetailsBox product={product} headline={headline} subHeadline={subHeadline} />
        </Flex>
        <ActionBox pl="24px" width={[1, null, null, null, 5 / 11 ]} flexDirection='column' justifyContent='center' color='background.light' px="24px" py={[3, null, null, null, 4]}>
          <Text color='primary' fontSize={3} fontWeight='bold' mb={"24px"} style={{ lineHeight: '24px' }} >
            {xSellMessaging}
          </Text>
          <BlockLink
            onClick={() =>{
              PCLNAnalytics.send({
                action: 'Feature Box CTA',
                data: 'Cross Sell Search Button'
              })
            }}
            href={xSellUrl} target='_new'>
              <Button data-autobot-element-id='XSELL_SEARCH_BUTTON' aria-label={`Search ${xSellTarget}`} role='button' size='large'  >
                Search {xSellTarget}
              </Button>
          </BlockLink>
        </ActionBox>
      </Flex>
    </Wrapper>
  )
}
